import { CommonStatus } from "@/Common/Models/Patient/Enum/CommonStatus";
import { Patient } from "@/Common/Models/Patient/Patient";
import { OntarioPatientEnrollmentModel } from "@/Common/Models/Patient/PatientEnrollment/Ontario/OntarioPatientEnrollmentModel";
import { PatientRefIntervenorWithDetailsModel } from "@/Common/Models/Patient/PatientRefIntervenorWithDetailsModel";

class OntarioEnrollmentHelper {
    private patient: Patient;
    private enrollment: OntarioPatientEnrollmentModel;

    constructor(patient: Patient, enrollment: OntarioPatientEnrollmentModel) {
        this.patient = patient;
        this.enrollment = enrollment;
    }

    public getPhysicianStatus(): CommonStatus {
        if (IsNullOrWhiteSpace(this.enrollment.Id))
            return CommonStatus.NotCovered;

        return this.enrollment.isCurrentEnrollment()
            ? CommonStatus.Covered
            : CommonStatus.Terminated;
    }

    public getPhysicianStatusInfo(status: CommonStatus): string {
        if (status === CommonStatus.Covered)
            return this.getEnrollmentPhysician();

        return status === CommonStatus.Terminated
            ? cacheStore.GetString("EnrolmentTerminatedLabel")
            : cacheStore.GetString("NotEnrolledLabel");
    }

    public getPrimaryPhysician(): string {
        const familyDoctor: PatientRefIntervenorWithDetailsModel = this.patient.GetAttendingDoctorOrSpecialistOnfileIntervenor();

        return familyDoctor?.GetName() ?? "";
    }

    private getEnrollmentPhysician(): string {
        const employee = cacheStore.GetEmployeeByContactFacetId(this.enrollment?.EnrolledPhysicianId);

        if (!employee)
            return null;

        const prefix = cacheStore.GetLocalizedValueByLookupId(employee.PrefixLookupId);

        return prefix
            ? `${prefix} ${employee.FirstName} ${employee.LastName}`
            : `${employee.FirstName} ${employee.LastName}`;
    }
}

export { OntarioEnrollmentHelper };
